'use client';

import {
  Provider,
  create,
  remove,
  show,
  useModal,
  register,
} from '@ebay/nice-modal-react';

import { wait } from '@wwe-portal/ui/lib/timer';

export const PortableDialogProvider = Provider;
PortableDialogProvider.displayName = 'PortableDialogProvider';

export const usePortableDialog = useModal;
export const createPortableDialog = create;
export const removeDialog = remove;

export const showDialog = async <T, C, P extends Partial<C>>(
  modal: React.FC<C>,
  args?: P
) => {
  // Wait all click outside events are bubbled. Once dialog is shown, events can not be bubbled to root
  await wait(0);
  return show<T, C, P>(modal, args);
};

export const showDialogById = async (
  id: string,
  args?: Record<string, unknown>
) => {
  // Wait all click outside events are bubbled. Once dialog is shown, events can not be bubbled to root
  await wait(0);
  return show(id, args);
};

export const registerDialog = register;
